// LivestreamScrollHint.jsx

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import HintSwipeMobileResource from '../../img/ic-hint-swipe-mobile.svg';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import defaults from '../resource/defaults.js';
import media from '../style/media.js';
import { color } from '../style/variables.js';

export const LivestreamScrollHint = ({
  setHasScrollHintDisplayed = defaults.NULL_FUNCTION,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    return () => {
      setHasScrollHintDisplayed();
    };
  }, [setHasScrollHintDisplayed]);

  return (
    <ScrollHintUI>
      <ScrollHintImg
        width={60}
        height={60}
        src={HintSwipeMobileResource}
        alt=""
      />
      <ScrollHintUIText>
        {t('swipe_livestream_hint', {
          ns: TranslationNamespace.LIVESTREAM,
        })}
      </ScrollHintUIText>
    </ScrollHintUI>
  );
};

LivestreamScrollHint.propTypes = {
  setHasScrollHintDisplayed: PropTypes.func,
};

const ScrollHintUI = styled.div`
  max-width: 260px;
  padding: 12px;
  gap: 4px;
  justify-content: center;
  align-items: center;
  background-color: ${color.black};
  display: flex;
  flex-direction: column;
  border-radius: 4px;

  animation: fadeinout 4s linear forwards;
  opacity: 0;
  @keyframes fadeinout {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 1;
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

const ScrollHintImg = styled.img`
  height: 100px;
  width: 100px;
  ${media.mobile`
    height: 60px;
    width: 60px;
  `}
`;

const ScrollHintUIText = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.014px;
  text-align: center;
`;

export default LivestreamScrollHint;
